import { ToolsAction, ToolsActionType } from '../_actions/ToolsActions';
import ToolsStore from '../_stores/ToolsStore';

const ToolsReducer = (store:ToolsStore = new ToolsStore(), action: ToolsAction):ToolsStore => {
	switch (action.type) {
		case ToolsActionType.OnToggleGrid:
			return store.setIn(['grid','enabled'], !store.getIn(['grid','enabled']));

		case ToolsActionType.OnToggleRulers:
			return store.setIn(['rulers','enabled'], !store.getIn(['rulers','enabled']));

		case ToolsActionType.OnToggleOverlay:
			return store.setIn(['overlay','enabled'], !store.getIn(['overlay','enabled']));

		case ToolsActionType.OnTogglePreviewFabric:
			return store.setIn(['previewFabric','enabled'], !store.getIn(['previewFabric','enabled']));

		case ToolsActionType.OnPreviewFabricSetSize:
			store = store.setIn(['previewFabric','width'], action.width);
			store = store.setIn(['previewFabric','height'], action.height);
			return store;

		case ToolsActionType.OnSetRepeatMode:
			return store.setIn(['repeatMode', 'type'], action.type)

		case ToolsActionType.OnToggleRepeatMode:
			return store.setIn(['repeatMode','type'], store.getIn(['repeatMode','type']) === 'tile' ? 'panel' : 'tile');
	}
	return store;
}

export default ToolsReducer